<template>
    <div>
        <div class="c-breadcrumb l-container" v-if="layout_flag">
            <ul class="c-breadcrumb__list">
                <li class="c-breadcrumb__item"><a href="/">TOP</a></li>
                <li class="c-breadcrumb__item"><a href="">ログイン</a></li>
            </ul>
        </div>
        <div class="l-main l-container">
            <div class="c-column">
                <div class="c-block__headings">
                    <h2>ログイン</h2>
                </div>
                <div class="c-input__block">
                    <div class="c-input__item">
                        <div class="c-input__header">
                            メールアドレス
                        </div>
                        <div class="c-input__area" :class="{'is-error': validations.email.isInvalid}">
                            <input type="email" placeholder="入力してください" v-model="user.email" @blur="checkMail" @focus="resetValidation('email')" name="MEMBER_ACOUNT_ID">
                            <div class="c-input__error">
                                <p class="c-input__error-match" :class="{'is-show': validations.email.isInvalid}">正しいメールアドレスを入力してください。</p>
                            </div>
                        </div>
                    </div>
                    <div class="c-input__item">
                        <div class="c-input__header">
                            パスワード
                        </div>
                        <div class="c-input__area c-input__password c-input__password1" :class="{'is-error': validations.password.isInvalid||hasAuthError()}">
                            <input type="password" name="PSWD_HASH" placeholder="入力してください" v-model="user.password" @blur="checkPassword" @focus="resetValidation('password')">

                            <div class="c-input__error">
                                <p class="c-input__error-match" :class="{'is-show': validations.password.isInvalid}">パスワードを入力してください。</p>
                                <p class="c-input__error-match" :class="{'is-show': hasAuthError()}">{{authErrorMessages}}</p>
                            </div>
                        </div>
                    </div>

                    <div class="c-input__confirm">
                        <div class="c-input__checkbox-wrapper">
                            <input id="box1" type="checkbox" name="remember" v-model="isRememberChecked" />
                            <label for="box1">次回から自動的にログインする</label>
                        </div>
                    </div>

                    <div class="c-btn-important1">
                        <button type="submit" @click="login">ログイン</button>
                    </div>

                    <ul class="forgot">
                        <li><a :href="route(route_list, 'site.password.reset')">パスワードを忘れた方はこちら</a></li>
                        <li><a :href="getLink('faq')">ログインできない方はこちら</a></li>
                    </ul>
                </div>
                <!-- c-input__block -->
                <div class="member" v-if="layout_flag">
                    <p class="c-bookname u-mb15-pc u-mb10-sp">アカウントをお持ちでない方はこちら</p>
                    <div class="c-btn-normal2">
                        <a :href="route(route_list, 'site.signup.index')">アカウント登録(無料)</a>
                    </div>
                </div>
            </div>
            <!-- c-column -->
        </div>
        <!-- l-main -->
    </div>
</template>

<script>
    import routeMixin from '../../mixins/route.js';
    export default {
        props: [
            'errors',
            'old',
            'links',
            'route_list',
            'layout_flag'
        ],
        mixins: [routeMixin],
        data() {
            return {
                authErrorMessages: this.getAuthError(),
                user: {
                    'email': this.getOldData('MEMBER_ACOUNT_ID'),
                    'password': ''
                },
                validations: {
                    email: {
                        isInvalid: false,
                        regex: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/
                    },
                    password: {
                        isInvalid: false,
                    },
                },
                auth: {
                    isInvalid: false,
                },
                isRememberChecked: this.hasChecked()
            }
        },
        methods: {
            login(e) {
                this.checkMail();
                this.checkPassword();
                if (this.validations.email.isInvalid || this.validations.password.isInvalid) {
                    e.preventDefault();
                    return false;
                }
                return true;
            },
            checkMail() {
                if (this.user.email === "" || !this.validations.email.regex.test(this.user.email)) {
                    this.validations.email.isInvalid = true;
                } else {
                    this.validations.email.isInvalid = false;
                }
            },
            getOldData(target) {
                if (typeof this.old === 'object' && Object.keys(this.old).length > 0 && this.old[target]) {
                    return this.old[target];
                }
                return '';
            },
            hasChecked() {
                let old_data = '';
                old_data = this.getOldData('remember');
                return old_data === 'on';
            },
            checkPassword() {
                this.auth.isInvalid = false;
                if (this.user.password === '') {
                    this.validations.password.isInvalid = true;
                } else {
                    this.validations.password.isInvalid = false;
                }
            },
            getAuthError() {
                let message = '';
                if (typeof this.errors === 'object' && Object.keys(this.errors).length > 0 && this.errors['MEMBER_ACOUNT_ID']) {
                    message = this.errors['MEMBER_ACOUNT_ID'][0];
                }
                return message;
            },
            hasAuthError() {
                return this.authErrorMessages.length > 0;
            },
            resetValidation(type) {
                if (type === 'email') {
                    this.authErrorMessages = '';
                    this.validations.email.isInvalid = false;
                }
                if (type === 'password') {
                    this.authErrorMessages = '';
                    this.validations.password.isInvalid = false;
                }
            },
            getLink(target) {
                let link = '/';
                if (this.links[target]) {
                    link = this.links[target];
                }
                return link;
            }
        },

        mounted(){
            if (this.layout_flag == false) {
                var login_form = document.querySelector('div.c-input__block');
                login_form.style.border = 'none';
            }
        }
    }
</script>

<style lang="scss" scoped>
    .c-column {
        padding: 0 20px 100px;
        width: 100%;

        @media screen and (max-width: 767px) {
            padding: 40px 0;
        }

        .c-input__block {
            max-width: 620px;
            margin: 0 auto 50px;
            padding: 0 0 50px;
            border-bottom: 1px dotted #dce8ec;

            @media screen and (max-width: 767px) {
                padding: 0;
                border-bottom: none;
            }

            .c-input__area input {
                @media screen and (min-width: 768px) {
                    width: 475px;
                }
            }

            .c-input__item .c-input__area.is-error .c-input__caution,
            .c-input__item .c-input__area.is-error .c-input__error {
                width: auto;
            }

            .forgot {
                padding: 20px 0 0;
                text-align: center;
                font-size: 14px;
                line-height: 1.5;

                li {
                    margin: 0 0 5px;

                    a {
                        color: #00b3d6;
                        text-decoration: underline;
                        display: inline-block;
                    }
                }
            }

            .c-input__confirm > .c-input__checkbox-wrapper {
                text-align: center;
            }
        }

        .c-btn-important1,
        .c-btn-important2 {
            margin-right: 0;
        }

        .member {
            text-align: center;
        }
    }
</style>